import React from 'react';

const ChevronDownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" fill="none" viewBox="0 0 10 7">
    <path stroke="#16C79A" strokeLinecap="round" strokeWidth="2" d="M1.18 1.623l3.719 4.13M8.835 1.623l-3.72 4.13" />
  </svg>
);

export default ChevronDownIcon;
